var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudIndex',{attrs:{"title":"Project Priorities","viewColumns":_vm.columns,"fetchUrl":"/project-priorities","createUrl":"/project-priorities","updateRootUrl":"/project-priorities","deleteRootUrl":"/project-priorities","reloadOnSuccess":true,"createFields":_vm.createFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }